<script setup lang="ts">
import { miUsuario } from '@/services/usuarios';
import { ref } from 'vue';
import { defineProps, onMounted } from 'vue';

// Definimos las propiedades configurables
const props = defineProps({
  text: {
    type: String,
    default: '80% OFF EN TODOS LOS CURSOS DE HERNÁN CON TU CÓDIGO: #ORSAI2025',
  },
  buttonText: {
    type: String,
    default: 'Usar cupón',
  },
  link: {
    type: String,
    default: '#', // URL por defecto
  },
  backgroundColor: {
    type: String,
    default: 'bg-blue-500', // Clase Tailwind para el color de fondo
  },
  textColor: {
    type: String,
    default: 'text-white', // Clase Tailwind para el color del texto
  },
  buttonBackgroundColor: {
    type: String,
    default: 'bg-black', // Clase Tailwind para el color de fondo del botón
  },
  buttonTextColor: {
    type: String,
    default: 'text-white', // Clase Tailwind para el color del texto del botón
  },
});

function generarCheckoutURL(baseURL, usuario) {
  console.log("Usuario:", usuario);
    const queryParams = {
        "checkout[email]": usuario.email,
        "checkout[billing_address][first_name]": usuario.nombre,
        "checkout[billing_address][last_name]": usuario.apellido,
        "checkout[billing_address][address1]": usuario.direccion,
        "checkout[billing_address][address2]": usuario.dirPisoDepto || "",
      "checkout[billing_address][city]": usuario.ciudad,
      // Provincia o estado
        "checkout[billing_address][province]": usuario.provincia,
      "checkout[billing_address][zip]": usuario.codigoPostal,
      // Phone
        "checkout[phone]": usuario.telefono,
    };

    // Convertir el objeto a un query string
    const queryString = Object.keys(queryParams)
        .map(key => `${(key)}=${(queryParams[key])}`)
        .join('&');

    // Combinar la base URL con el query string
    const separador = baseURL.includes('?') ? '&' : '?';
  return `${baseURL}${separador}${queryString}`;
}

const linkConCheckout = ref('');
onMounted(async () => {
  // Lógica para inicializar el componente
  const usuario = await miUsuario();
  linkConCheckout.value = generarCheckoutURL(props.link, usuario);
  console.log("Link con checkout:", linkConCheckout);
});


</script>

<template>
  <div :class="[backgroundColor, 'flex justify-between items-center p-4 rounded-lg flex-col md:flex-row md:py-6 md:px-8']">
    <span :class="[textColor, 'font-medium text-sm md:text-base']" v-html="text">
    </span>
    <a
      :href="linkConCheckout"
      :class="[buttonBackgroundColor, buttonTextColor, 'py-2 px-4 rounded-md font-medium text-sm mt-2 md:my-0']"
    >
      {{ buttonText }}
    </a>
  </div>
</template>

<style scoped>
/* Puedes agregar estilos adicionales aquí si es necesario */
</style>
